/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains a hook that proxies a hook from 
 * online-patient-management-reducers making less types required to use the hook.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Required to make use of JSX functionality
 */
import * as React from 'react';


import MuiCheckbox, { CheckboxProps as MuiCheckboxProps } from '@material-ui/core/Checkbox';

import { FieldRenderProps } from 'react-final-form';
/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

import FormControlLabel from '@material-ui/core/FormControlLabel';

/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */

type CheckboxsProps = Partial<Omit<MuiCheckboxProps, 'type'>> & FieldRenderProps<any, any>

interface ICheckbox extends CheckboxsProps {
    label?: string;
}

/*
 * ---------------------------------------------------------------------------------
 * Styles
 * ---------------------------------------------------------------------------------
 */


/*
 * ---------------------------------------------------------------------------------
 * components
 * ---------------------------------------------------------------------------------
 */

const Checkbox: React.FunctionComponent<ICheckbox> = ({
    input: { name, value, onChange: onInputChange, checked, ...restInput },
    meta,
    label,
    onChange,
    ...rest
}) => {

    const onChangeCombined = React.useCallback((event: React.ChangeEvent<HTMLInputElement>, checkedValue: boolean) => {
        if (onChange) {
            onChange(event, checkedValue);
        }

        onInputChange(event);
    }, [onChange, onInputChange]);

    const checkbox = (
        <MuiCheckbox
            {...rest as any}
            inputProps={{ ...restInput }}
            name={name}
            value={value}
            checked={checked}
            onChange={onChangeCombined}
        />
    );

    if (!label) {
        return checkbox;
    }

    return (
        <FormControlLabel
            control={checkbox}
            label={label}
        />
    );
}

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default Checkbox;
